const trimTrailingZeros = (value) => value.replace(/\.0+$/, "").replace(/(\.\d*[1-9])0+$/, "$1");

const formatCompactValue = (value) => {
    let decimals = 0;
    if (value < 10) {
        decimals = 2;
    } else if (value < 100) {
        decimals = 1;
    }
    return trimTrailingZeros(value.toFixed(decimals));
};

export const formatCompactNumber = (value) => {
    if (!Number.isFinite(value)) {
        return "";
    }

    const abs = Math.abs(value);
    const sign = value < 0 ? "-" : "";

    if (abs >= 1e12) {
        return `${sign}${formatCompactValue(abs / 1e12)}T`;
    }
    if (abs >= 1e9) {
        return `${sign}${formatCompactValue(abs / 1e9)}B`;
    }
    if (abs >= 1e6) {
        return `${sign}${formatCompactValue(abs / 1e6)}M`;
    }
    if (abs >= 1e3) {
        return `${sign}${formatCompactValue(abs / 1e3)}K`;
    }

    return `${sign}${abs.toLocaleString()}`;
};

export const formatCompactNumberKR = (value) => {
    if (!Number.isFinite(value)) {
        return "";
    }

    const abs = Math.abs(value);
    const sign = value < 0 ? "-" : "";

    if (abs >= 1e12) {
        return `${sign}${formatCompactValue(abs / 1e12)}조`;
    }
    if (abs >= 1e8) {
        return `${sign}${formatCompactValue(abs / 1e8)}억`;
    }
    if (abs >= 1e4) {
        return `${sign}${formatCompactValue(abs / 1e4)}만`;
    }

    return `${sign}${abs.toLocaleString()}`;
};
